import { Icon } from "@iconify/react"
import { Button } from "@mantine/core"
import { Icons } from "src/components/ui/Icons"
import { useActions, useAppState } from "src/state"

export const ViewModeToggle = () => {

    const { view } = useAppState(state=>state.ui)
    const toggleUIViewMode = useActions().toggleUIViewMode

    return (
        <Button
            px={8}
            variant="outline"
            color="gray"
            className="border-theme-global"
            onClick={toggleUIViewMode}
        >
            <Icon icon={view==='cards'?Icons.list:Icons.cards} width={20} />
        </Button>
    )

}